import axios_ from "@/utils/axios";
import {
  registerWaba,
  registerBusinessAppWaba,
  setBusinessAppSyncConsent,
  getWabaList,
  phoneRetrieve,
  getWabaPhoneList,
  initializeWhatsAppPhoneList,
  getWhatsAppTemplate,
  getWhatsAppTemplateList,
  whatsAppSendTaskInsert,
  whatsAppSendTaskList,
  whatsAppSendTaskSetEnd,
  whatsAppSendTaskEstimate,
  whatsAppSendTaskRiskCheck,
  whatsAppSendTaskGetSummary,
  whatsAppSendTaskGetTaskDetails,
  whatsAppSendTaskOptionWhatsappUser,
} from "./whatsApp.python.js";


export default {
  /**
   * waba_id注册
   * @param {string} waba_id
   * @param {string} phone_number_id
   * @param {string} code 嵌入式注册返回的 code
   * @returns { Promise<{code:number;msg:string;data:any}> }
   */
  registerWaba,

  /**
   * WhatsApp Business App 共存账户授权
   * @param {string} waba_id 共存账户 onboarding 返回的 WABA ID
   * @param {string} phone_number_id 共存账户 onboarding 返回的手机号 ID
   * @param {string} code 嵌入式注册返回的 code
   * @returns { Promise<{code:number;msg:string;data:any}> }
   */
  registerBusinessAppWaba,

  /**
   * WhatsApp Business App 共存账户同步授权
   * @param {string} waba_id WABA 账户 ID，即 WhatsAppPage.page_id
   * @param {string} [phone_number_id] 电话号码编号，缺省时后端自动取该页首个号码
   * @param {Array<"smb_app_state_sync"|"history">} [sync_types] 同步联系人和聊天历史
   * @returns { Promise<{code:number;msg:string;data:any}> }
   */
  setBusinessAppSyncConsent,

  /**
   * WhatsApp媒体授权列表
   * @param { {page_name?:string; page:number; page_num:number} } params
   * @returns {Promise<{code:number;msg:string;data:any}>}
   */
  getWabaList,

  /**
   * 检索手机号
   * @param {string} waba_id
   * @param {string} phone_number_id
   * @returns {Promise<{code:number;msg:string;data:any}>}
   */
  phoneRetrieve,

  /**
   * 注册手机号
   * @param {string} waba_id
   * @param {string} phone_number
   * @returns {Promise<{code:number;msg:string;data:{phone_id:string;page_id:string;phone_number:string}}>}
   */
  wabaPhoneRegister(waba_id, phone_number) {
    return axios_("POST", "api/pandagpt/v1/whatsApp/phoneRegister", { waba_id, phone_number });
  },

  /**
   * 获取whatsapp手机号列表
   * @param {{page_id:string;page:number;page_num:number}} params
   * @returns {Promise<{code:number;msg:string;data:any}>}
   */
  getWabaPhoneList,

  /**
   * 初始化WhatsApp手机号列表
   * @param {string} page_id 主页ID
   * @returns {Promise<{code:number;msg:string;data:any}>}
   */
  initializeWhatsAppPhoneList,

  /**
   * 添加群发任务
   * @param {Record<string,any>} params
   * @returns {Promise<DefaultResponseType>}
   */
  whatsAppSendTaskInsert,
  /**
   * 修改群发任务
   * @param {Record<string,any>} params
   * @returns {Promise<{code:number;msg:string;data:any}>}
   */
  whatsAppSendTaskUpdate(params) {
    return axios_("POST", "api/pandagpt/v1/whatsAppSendTask/update", params);
  },

  /**
   * 获取群发任务列表
   * @param {{status?:1|2|3;name?:string;start_dt?:string;end_dt?:string;user?:string;page?:number;page_num?:number}} params
   * @returns {Promise<{code:number;msg:string;data:any}>}
   */
  whatsAppSendTaskList,

  /**
   * 结束群发任务
   * @param {string} id
   * @returns {Promise<{code:number;msg:string;data:any}>}
   */
  whatsAppSendTaskSetEnd,


  /**
   * 删除群发任务
   * @param {string} id
   * @returns {Promise<{code:number;msg:string;data:any}>}
   */
  whatsAppSendTaskDel(id) {
    return axios_("POST", "api/pandagpt/v1/whatsAppSendTask/del", { id });
  },

  /**
   * 上传手机号
   * @param {FormData} formData
   * @returns {Promise<{code:number;msg:string;data:any}>}
   */
  whatsAppSendTaskUploadExpress(formData) {
    return axios_("POST", "api/pandagpt/v1/whatsAppSendTask/uploadExpress", formData,false,false,true);
  },

  /**
   * 获取 whatsapp 模板
   */
  getWhatsAppTemplate,
  /**
   * 同步 whatsapp 模板列表
   * @param page_id
   * @returns {Promise<{code:number;msg:string;data:any}>}
   */
  getWhatsAppTemplateList,
  /**
   * 下载目标用户上传模板
   * @returns {string}
   */
  whatsAppSendTaskOrderPhoneDownload() {
    return "api/pandagpt/v1/whatsAppSendTask/orderPhoneDownload?token=" + (localStorage.getItem("token") || "");
  },

  /**
   * 获取任务详情
   * @param {string} id
   * @returns {Promise<{code:number;msg:string;data:any}>}
   */
  whatsAppSendTaskDetail(id) {
    return axios_("GET", "api/pandagpt/v1/whatsAppSendTask/details", { id });
  },
  /**
   * 获取任务汇总数据
   * @param {string} id 任务ID
   * @returns {Promise<{code:number;msg:string;data:any}>}
   */
  whatsAppSendTaskGetSummary,


  /**
   * 任务详细数据
   * @param {Object} params
   * @returns {Promise<{code:number;msg:string;data:any}>}
   */
  whatsAppSendTaskGetTaskDetails,

  /**
   * 根据选中的tag列表筛选手机号
   * @param {{page_id:string;country_code:string;label_id:Array<{id:string;name:string}>}} params
   * @returns {Promise<{code:number;msg:string;data:any}>}
   */
  whatsAppSendTaskOptionWhatsappUser,

  /**
   * 计算预估花费
   */
  whatsAppSendTaskAnalyzeUsers: whatsAppSendTaskEstimate,
  /**
   * 群发任务风控校验，调用预估金额前必须通过。
   * @param {Record<string,any>} params
   * @returns {Promise<DefaultResponseType>}
   */
  whatsAppSendTaskRiskCheck,
};
